export interface CreatorGoogleSearch {
	type: string;
}

export enum CreatorAgentSuccessFlowStepKey {
	ActivateAccount = 'ACTIVATE_ACCOUNT',
	ScheduleCall = 'SCHEDULE_CALL',
	GetChatbot = 'GET_CHATBOT',
	StartReceivingCalls = 'START_RECEIVING_CALLS',
	StartMakingCalls = 'START_MAKING_CALLS',
	AccessDashboard = 'ACCESS_DASHBOARD'
}

export enum CreatorAgentSuccessFlowVariant {
	Default = 'default',
	Collapse = 'collapse'
}

export enum CreatorAgentSuccessRedirectTarget {
	Dashboard = 'dashboard',
	AgentConfiguration = 'agent_configuration'
}

export interface CreatorAgentSuccessFlowStep {
	key: CreatorAgentSuccessFlowStepKey;
	next_step?: CreatorAgentSuccessFlowStepKey;
	url?: string | null;
}

export interface CreatorAgentSuccessFlow {
	variant: CreatorAgentSuccessFlowVariant;
	is_stepper_included: boolean;
	steps: CreatorAgentSuccessFlowStep[];
}

export type CreatorVideoMapKey =
	| 'intro'
	| 'training_waiting'
	| 'success_modal'
	| 'activate_account'
	| 'next_steps_intro';

export type CreatorOpenDestination = 'internal' | 'external';
export type CreatorOpenMode = 'page' | 'overlay' | 'mini';

export interface CreatorOpeningConfig {
	destination: CreatorOpenDestination;
	mode?: CreatorOpenMode;
}

export type CreatorOpeningStrategy = Record<string, CreatorOpeningConfig>;

export interface CreatorCustomerForm {
	is_external_account_number_enabled: boolean;
}

export interface CreatorSuccessPage {
	checkout_product_key: string;
	is_consultation_link_visible: boolean;
	is_next_steps_visible: boolean;
	is_portal_link_visible: boolean;
	promotion_code: string | null;
}

export interface CreatorSettings {
	agent_success_flow?: CreatorAgentSuccessFlow;
	checkout_success_return_url: string | null;
	source_input: string[] | null;
	instructions_url: string;
	privacy_policy_url: string;
	terms_of_services_url?: string | null;
	videos?: { key: CreatorVideoMapKey; url: string }[];
	google_search: CreatorGoogleSearch;
	customer_form: CreatorCustomerForm;
	success_page: CreatorSuccessPage;
	opening_strategy?: CreatorOpeningStrategy;
	onboarding_carousel_phrases?: string[];
}
